import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Header from "./components/Header.jsx";
import Sidebar from "./components/Sidebar.jsx";
import Home from "./components/Home.jsx";
import About from "./components/About.jsx";
import AboutDAS from "./components/about/AboutDAS.jsx";
import Members from "./components/about/Members.jsx";
import ContactUs from "./components/about/ContactUs.jsx";
import BoostInnovation from "./components/boost_innovation/BoostInnovation.jsx";
import SolutionsAndInsights from "./components/SolutionsAndInsights";
import SolutionsAndInsightsViewer from "./components/SolutionsAndInsightsViewer.jsx";
import OperationsHub from "./components/OperationsHub.jsx";
import EngagementStateMachine from "./components/operations_hub/EngagementStateMachine.jsx";
import ProjectPipeline from "./components/operations_hub/ProjectPipeline.jsx";
import ExpirationTracker from "./components/operations_hub/ExpirationTracker.jsx";
import AppRegistrationHelper from "./components/operations_hub/AppRegistrationHelper.jsx";
import ResourcesAndReusables from "./components/resources_and_reusables/ResourcesAndReusables.jsx";
import CodeContribution from "./components/resources_and_reusables/CodeContribution.jsx";
import UIDesignGallery from "./components/resources_and_reusables/UIDesignGallery.jsx";
import ReusableCatalog from "./components/resources_and_reusables/ReusableCatalog.jsx";
import CommercialAndRd from "./components/resources_and_reusables/CommercialAndRD.jsx";
import ITSRoadmap from "./components/operations_hub/ITSRoadmap.jsx";
import Roadmap from "./components/Roadmap.jsx";

import SignIn from "./components/auth/SignIn.jsx";
import RequireAuth from "./components/auth/RequireAuth.jsx";
import Callback from "./components/auth/Callback.jsx";
import ActivityHandler from "./components/ActivityHandler.jsx";

import { bootstrapUI } from "./ui.js";
import NotFound from "./components/NotFound.jsx";

function mount() {
  bootstrapUI();

  const path = window.location.pathname || "";

  const render = (el, node) => {
    if (!el) return false;
    createRoot(el).render(
      <BrowserRouter basename="/">
        <ActivityHandler>{node}</ActivityHandler>
      </BrowserRouter>,
    );
    return true;
  };

  const secureRender = (el, node, opts = {}) => {
    if (!el) return false;
    const { showUnauthorized = true } = opts;
    createRoot(el).render(
      <BrowserRouter>
        <ActivityHandler>
          <RequireAuth showUnauthorized={showUnauthorized}>{node}</RequireAuth>
        </ActivityHandler>
      </BrowserRouter>,
    );
    return true;
  };

  // Public: callback DO NOT wrap
  if (path === "/callback") {
    const callbackEl = document.getElementById("callback");
    render(callbackEl, <Callback />);
    return;
  }

  if (path === "/") {
    const signInEl = document.getElementById("react-sign-in");
    render(signInEl, <SignIn />);
    return;
  }

  // Standalone legacy roadmap page - not part of the #appRoot SPA routes,
  // has its own dedicated mount point instead.
  if (path === "/its-roadmap" || path === "/its-roadmap/") {
    const roadmapEl = document.getElementById("react-roadmap");
    secureRender(roadmapEl, <Roadmap />, { showUnauthorized: true });
    return;
  }

  const homeEl = document.getElementById("appRoot");
  if (
    secureRender(
      homeEl,
      <>
        <Header />

        <div id="modal" />
        <div id="expanded-pane" />

        <div className="app-body">
          <Sidebar />

          <main className="page-content">
            <Routes>
              <Route path="*" element={<Navigate to="/404" replace />} />
              <Route path="/home" element={<Home />} />

              {/* ABOUT PAGES */}
              <Route path="/about" element={<About />} />
              <Route path="/about/about-its" element={<AboutDAS />} />
              <Route path="/about/members" element={<Members />} />
              <Route path="/about/contact-us" element={<ContactUs />} />

              {/* Boost Innovation */}
              <Route path="/boost-innovation" element={<BoostInnovation />} />

              {/* Solutions and Insights */}
              <Route path="/solutions-and-insights" element={<SolutionsAndInsights />} />
              <Route path="/solutions/view/" element={<SolutionsAndInsightsViewer />} />

              {/* Operations Hub */}
              <Route path="/operations-hub" element={<OperationsHub />} />
              <Route path="/operations-hub/its-roadmap" element={<ITSRoadmap />} />
              <Route
                path="/operations-hub/engagement-state-machine"
                element={<EngagementStateMachine />}
              />
              <Route path="/operations-hub/project-pipeline" element={<ProjectPipeline />} />
              <Route path="/operations-hub/expiration-tracker" element={<ExpirationTracker />} />
              <Route
                path="/operations-hub/app-registration-helper"
                element={<AppRegistrationHelper />}
              />

              {/* Resources and Reusables */}
              <Route path="/resources-and-reusables" element={<ResourcesAndReusables />} />
              <Route
                path="/resources-and-reusables/code-contribution"
                element={<CodeContribution />}
              />
              <Route
                path="/resources-and-reusables/ui-design-gallery"
                element={<UIDesignGallery />}
              />
              <Route
                path="/resources-and-reusables/reusable-catalog"
                element={<ReusableCatalog />}
              />
              <Route
                path="/resources-and-reusables/commercial-and-rd"
                element={<CommercialAndRd />}
              />
            </Routes>
          </main>
        </div>
      </>,
      { showUnauthorized: true },
    )
  )
    return;

  const errorEl = document.getElementById("errRoot");
  secureRender(errorEl, <NotFound />, { showUnauthorized: false });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", mount);
} else {
  mount();
}
